// Modal para crear una empresa nueva. Al crearla, el backend clona
// automáticamente los documentos plantilla, así que aquí solo se muestra
// un mensaje de éxito con el conteo devuelto.
import { useState } from "react";
import { X, Building2, CheckCircle, Loader } from "lucide-react";
import { api } from "../api";

export default function CompanyModal({ onClose, onCreated }) {
  const [form, setForm]     = useState({ name: "", nit: "", sector: "", city: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone]     = useState(false);
  const [docCount, setDocCount] = useState(0);
  const [error, setError]   = useState(null);

  const set = (k) => (e) => setForm(p => ({ ...p, [k]: e.target.value }));

  const handleSubmit = async () => {
    if (!form.name.trim()) return;
    setLoading(true);
    setError(null);
    try {
      const company = await api.createCompany(form);
      if (company.error) throw new Error(company.error);
      setDocCount(company.doc_count || 0);
      setDone(true);
      setTimeout(() => { onCreated(company); onClose(); }, 1800);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={{ maxWidth: 480 }}>
        <div className="modal-header">
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 36, height: 36, borderRadius: 8, background: "#F0FDFA", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Building2 size={18} style={{ color: "var(--primary)" }} />
            </div>
            <h2>Nueva empresa</h2>
          </div>
          <button className="btn-icon" onClick={onClose}><X size={20} /></button>
        </div>

        {done ? (
          <div className="modal-success">
            <CheckCircle size={48} className="success-icon" />
            <p>¡Empresa creada!</p>
            <p style={{ fontSize: "0.78rem", color: "var(--text-muted)", textAlign: "center" }}>
              Se copiaron <strong>{docCount}</strong> documento{docCount !== 1 ? "s" : ""} del paquete base.
            </p>
          </div>
        ) : (
          <>
            <div className="modal-form">
              <div className="form-row">
                <label>Nombre de la empresa *</label>
                <input className="form-input" autoFocus value={form.name} onChange={set("name")}
                  placeholder="Ej: Constructora ABC S.A.S" />
              </div>
              <div className="form-row two-col">
                <div>
                  <label>NIT</label>
                  <input className="form-input" value={form.nit} onChange={set("nit")}
                    placeholder="900.123.456-7" />
                </div>
                <div>
                  <label>Ciudad</label>
                  <input className="form-input" value={form.city} onChange={set("city")}
                    placeholder="Bogotá" />
                </div>
              </div>
              <div className="form-row">
                <label>Sector / Actividad económica</label>
                <input className="form-input" value={form.sector} onChange={set("sector")}
                  placeholder="Ej: Construcción, Salud, Manufactura..." />
              </div>

              {error && (
                <p style={{ color: "#C53030", fontSize: "0.78rem" }}>{error}</p>
              )}

              <div style={{ padding: "10px 14px", background: "#F0FDFA", borderRadius: 8, fontSize: "0.78rem", color: "#065F51" }}>
                Al crear la empresa se copiarán automáticamente todos los documentos del paquete base.
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn-secondary" onClick={onClose}>Cancelar</button>
              <button className="btn-primary" onClick={handleSubmit}
                disabled={!form.name.trim() || loading}>
                {loading
                  ? <><Loader size={15} className="spin" /> Creando...</>
                  : <><Building2 size={15} /> Crear empresa</>}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
